<template>
  <div class="freezer">
    <div class="content c895">
      <h2>Dodajte zamrzovalnik</h2>
    </div>
    <div class="content c590">
      <div class="form">
        <h3>VPIŠITE PODATKE O ZAMRZOVALNIKU</h3>
        <fieldset>
          <div class="f-item radio">
            <label>Tip zamrzovalnika:</label>
            <table id="ctl00_ContentPlaceHolder1_rblType" border="0">
              <tbody>
                <tr>
                  <td>
                    <input
                      id="ctl00_ContentPlaceHolder1_rblType_0"
                      type="radio"
                      name="ctl00$ContentPlaceHolder1$rblType"
                      value="1"
                      v-model="type"
                      @click="checker = !checker"
                      :checked="checker"
                    />
                    <label for="ctl00_ContentPlaceHolder1_rblType_0">Zamrzovalne omare</label>
                  </td>
                  <td>
                    <input
                      id="ctl00_ContentPlaceHolder1_rblType_1"
                      type="radio"
                      name="ctl00$ContentPlaceHolder1$rblType"
                      value="2"
                      v-model="type"
                      @click="checker = !checker"
                      :checked="!checker"
                    />
                    <label for="ctl00_ContentPlaceHolder1_rblType_1">Zamrzovalne skrinje</label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f-item select">
            <label>
              Prostornina:
              <span
                id="ctl00_ContentPlaceHolder1_RequiredFieldValidator1"
                style="color:Red;float:none;font-size:1em;visibility:hidden;"
              >*</span>
              <span>(oz. višina/širina)</span>
            </label>
            <select :style="{display: type == '1' ? 'none' : 'block'}" v-model="size">
              <option value="0">Izberite</option>
              <option value="1">110 cm - 230 l zamrzovalnika</option>
              <option value="2">130 cm - 290 l zamrzovalnika</option>
              <option value="3">94 cm - 184 l zamrzovalnika</option>
              <option value="4">112 cm - 225 l zamrzovalnika</option>
              <option value="5">160 cm - 368 l zamrzovalnika</option>
              <option value="6">135 cm - 287 l zamrzovalnika</option>
              <option value="7">85 cm - 300 l zamrzovalne skrinje</option>
              <option value="8">85 cm - 400 l zamrzovalne skrinje</option>
              <option value="9">85 cm - 150 l zamrzovalne skrinje</option>
            </select>
            <select
              name="ctl00$ContentPlaceHolder1$ddlSize"
              id="ctl00_ContentPlaceHolder1_ddlSize"
              :style="{display: type == '2' ? 'none' : 'block'}"
              v-model="size"
            >
              <option value="0">Izberite</option>
              <option value="1">180 cm - 261 l zamrzovalnika</option>
              <option value="2">180 cm - 217 l zamrzovalnika</option>
              <option value="3">177 cm - 274 l zamrzovalnika</option>
              <option value="4">150 cm - 208 l zamrzovalnika</option>
              <option value="5">85 cm - 83,5 l zamrzovalnika</option>
              <option value="6">85 cm - 90 l zamrzovalnika</option>
              <option value="7">61 cm - 53 l zamrzovalnika</option>
              <option value="8">153 cm - 174 l zamrzovalnika</option>
              <option value="9">141 cm - 168 l zamrzovalnika</option>
              <option value="10">163 cm - 240 l zamrzovalnika</option>
              <option value="11">173 cm - 210 l zamrzovalnika</option>
              <option value="12">140 cm - 164 l zamrzovalnika</option>
              <option value="13">165 cm - 193 l zamrzovalnika</option>
              <option value="14">170 cm - 210 l zamrzovalnika</option>
              <option value="15">155 cm - 259 l zamrzovalnika</option>
              <option value="16">170 cm - 296 l zamrzovalnika</option>
              <option value="17">185 cm - 277 l zamrzovalne omare</option>
              <option value="18">82 cm - 96 l zamrzovalne omare</option>
              <option value="19">84,5 cm - 94 l zamrzovalne omare</option>
            </select>
          </div>
          <div class="f-item select">
            <label>
              Energijski razred:
              <span
                id="ctl00_ContentPlaceHolder1_RequiredFieldValidator2"
                style="color:Red;float:none;font-size:1em;visibility:hidden;"
              >*</span>
              <span>(oz. leto izdelave naprave)</span>
            </label>
            <select
              name="ctl00$ContentPlaceHolder1$ddlClass"
              id="ctl00_ContentPlaceHolder1_ddlClass"
              v-model="kategorija"
            >
              <option value="0">Izberite</option>
              <option value="1">A+++ (po 2006)</option>
              <option value="2">A++ (po 2006)</option>
              <option value="3">A+ (po 2006)</option>
              <option value="4">A (po 2006)</option>
              <option value="5">B (2002-2006)</option>
              <option value="6">C (1999-2002)</option>
              <option value="7">D (1994-1999)</option>
              <option value="8">E (pred 1994)</option>
            </select>
          </div>
          <div class="commands">
            <input type="submit" value="Dodaj" @click="addedApplianceNum()" />
          </div>
        </fieldset>
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O ZAMRZOVALNIKU</h3>
        <p>Na področju racionalne rabe električne energije je mogoče zelo veliko doseči pri hlajenju in zamrzovanju hrane. “Varčen” hladilnik ali zamrzovalnik porabi polovico ali celo manj energije od starega, tehnološko zastarelega in izrabljenega.</p>

        <div class="average">
          <h4>Povprečna poraba zamrzovalnika</h4>
          <span>400 kWh/leto</span>
          <p>
            <strong>30,19 € / leto</strong> (enotarifno)
            <br />
            <strong>25,90 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZamrzovalnikObj from '../classes/zamrzovalnik';

export default {
  data: function () {
    return {
      checker: true,
      type: '1',
      kategorija: 0,
      size: '',
    };
  },
  methods: {
    addedApplianceNum() {
      const Z = new ZamrzovalnikObj(this.type, this.size, this.kategorija);
      console.log('From freezer');
      this.$emit('applianceFormClicked', Z);
    },
  },
};
</script>

<style>
</style>